/**
 * MessageDialog React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {clearDialogMessage} from "../../operations/message";
import Button from "@material-ui/core/Button";


const styles = theme => ({
    close: {
        padding: theme.spacing.unit / 2,
    },
});


export class MessageDialog extends React.Component {

    render() {

        const props = this.props;

        return (
            <Dialog
                open={props.open}
                onClose={this.props.clearDialogMessage}
                scroll='paper'
                fullWidth={true}
                maxWidth='md'
            >
                <DialogTitle id="scroll-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <pre>
                        {props.message}
                    </pre>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.clearDialogMessage} color="primary">
                      Close
                    </Button>
                  </DialogActions>
            </Dialog>
        );
    }
}

export default connect((state) => {
    return {
        message: state.messages.dialogMessage,
        open: state.messages.showDialogMessage,
        title: state.messages.dialogTitle
    }
}, {clearDialogMessage})(withStyles(styles)(MessageDialog))